import  PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { BRAND , IMAGES } from "@/lib/site";

const sections = [
  {
    title: "1. Introduction",
    content: [
      `Welcome to ${BRAND.name}. We respect your privacy and are committed to protecting the personal information you share with us through our website.`,
      "This Privacy Policy explains how we collect, use, store and protect your information whenever you visit our website or contact our team.",
    ],
  },
  {
    title: "2. Information We Collect",
    content: [
      "When you contact us or request a quotation, we may collect:",
    ],
    list: [
      "Full Name",
      "Company Name",
      "Email Address",
      "Phone Number",
      "Country & Location",
      "Product Requirements",
      "Project Details",
      "Messages submitted through the contact form",
    ],
  },
  {
    title: "3. How We Use Your Information",
    list: [
      "Respond to inquiries",
      "Prepare quotations",
      "Provide customer support",
      "Improve our products and services",
      "Communicate regarding orders",
      "Share important updates when required",
    ],
  },
  {
    title: "4. Data Protection & Security",
    content: [
      "We implement appropriate technical and organizational security measures to protect your information against unauthorized access, alteration or disclosure.",
      "Only authorized personnel have access to customer information.",
    ],
  },
  {
    title: "5. Cookies & Analytics",
    content: [
      "Our website may use cookies to improve browsing experience and website performance.",
      "Analytics tools may collect anonymous visitor statistics to help us improve our services.",
    ],
  },
  {
    title: "6. Third-Party Services",
    content: [
      "Our website may contain links or integrations with trusted third-party services including:",
    ],
    list: [
      "Google Maps",
      "Google Analytics",
      "WhatsApp",
      "Email Services",
      "Social Media Platforms",
    ],
  },
  {
    title: "7. Your Rights",
    list: [
      "Request access to your personal information",
      "Request correction of inaccurate information",
      "Request deletion of your data where applicable",
      "Withdraw communication consent",
    ],
  },
  {
    title: "8. Data Retention",
    content: [
      "We retain customer information only for as long as necessary for business, legal and customer support purposes.",
    ],
  },
  {
    title: "9. Contact Us",
    content: [
      "If you have any questions regarding this Privacy Policy, please contact us.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <>
      <PageHero
        overline="Legal"
        title="Privacy Policy"
        subtitle="Learn how Stenzia Displays LLP collects, uses and protects your information."
        image={IMAGES.PrivacyTerm}
      />

      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6">

          <Reveal>
            <div className="mb-12 p-6 rounded-2xl border border-stone-200 bg-stone-50">
              <div className="text-sm uppercase tracking-[0.2em] text-stenzia-green font-semibold">
                Last Updated
              </div>

              <h2 className="mt-3 text-2xl font-display">
                July 2026
              </h2>

              <p className="mt-4 text-stone-600 leading-relaxed">
                This Privacy Policy applies to all visitors, customers,
                distributors, dealers and business partners interacting with
                Stenzia Displays LLP through our website.
              </p>
            </div>
          </Reveal>

          <div className="space-y-8">

            {sections.map((section) => (

              <Reveal key={section.title}>

                <div className="rounded-3xl border border-stone-200 p-8 hover:shadow-xl transition-all duration-500">

                  <h2 className="text-2xl font-display text-charcoal">
                    {section.title}
                  </h2>

                  {section.content &&
                    section.content.map((paragraph, index) => (
                      <p
                        key={index}
                        className="mt-5 text-stone-600 leading-8"
                      >
                        {paragraph}
                      </p>
                    ))}

                  {section.list && (
                    <ul className="mt-5 space-y-3">

                      {section.list.map((item) => (

                        <li
                          key={item}
                          className="flex items-start gap-3"
                        >
                          <span className="mt-2 w-2 h-2 rounded-full bg-stenzia-green"></span>

                          <span className="text-stone-600 leading-7">
                            {item}
                          </span>

                        </li>

                      ))}

                    </ul>
                  )}

                </div>

              </Reveal>

            ))}

          </div>

        </div>
      </section>
    </>
  );
}